import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import LandingPage from './pages/LandingPage';
import AdminLogin from './components/AdminLogin';
import ImportSchedulePage from './pages/ImportSchedulePage';
import SchedulerDashboard from './pages/SchedulerDashboard';
import AdminLayout from './components/AdminLayout';
import AddRageRoom from './pages/AddRageRoom';
import BookingPage from './pages/BookingPage';
import BookingConfirmationPage from './pages/BookingConfirmationPage';
import {
  ConfigProvider,
  WebSocketProvider,
  UserProvider,
  TenantProvider,
  EmailTemplate,
  EmailTemplateDetail
} from 'm34n-ui';
import EditRageRoom from './pages/EditRageRoom';
import EditSchedulePage from './pages/EditSchedulePage';
import CancelBookingPage from './pages/CancelBookingPage';
import WaitlistPage from './pages/WaitlistPage';
import ScheduleVisualizer from './pages/ScheduleVisualizer';

// test
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ConfigProvider>
        <WebSocketProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/book" element={<BookingPage />} />
              <Route path="/book/confirmed" element={<BookingConfirmationPage />} />
              <Route path="/book/cancel/:bookingId" element={<CancelBookingPage />} />
              <Route path="/admin" element={
                <UserProvider AuthComponent={AdminLogin}>
                    <TenantProvider>
                        <AdminLayout />
                    </TenantProvider>
                </UserProvider>
              }>
                <Route index element={<SchedulerDashboard />} />
                <Route path="rooms" element={<SchedulerDashboard />} />
                <Route path="rooms/new" element={<AddRageRoom />} />
                <Route path="rooms/:roomId/edit" element={<EditRageRoom />} />
                <Route path="waitlist" element={<WaitlistPage />} />
                <Route path="schedules/import" element={<ImportSchedulePage />} />
                <Route path="schedules/edit" element={<EditSchedulePage />} />
                <Route path="schedules/visual" element={<ScheduleVisualizer />} />
                <Route path="email/templates" element={<EmailTemplate />} />
                <Route path="email/template/:emailTemplateId" element={<EmailTemplateDetail />} />
                <Route path="*" element={<Navigate to="/admin" replace />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </WebSocketProvider>
      </ConfigProvider>
    </ThemeProvider>
  );
}

export default App;
